import { requiredInput } from "@modules/form/formUtils"
import { AthleteNoteDraft, CoachNoteDraft, NoteType } from "@modules/sessionBlock/notes/noteTypes"
import * as Yup from "yup"

export type NoteInputKey = "note" | "noteType"

export type CoachNoteFormikType = {
  id: string | null
  note: string
  noteType: NoteType
  durationInMin?: number
}

export function getCoachNoteBlockValidationSchema() {
  return Yup.object().shape({
    note: requiredInput(Yup.string()),
    noteType: requiredInput(Yup.string().oneOf(Object.values(NoteType))),
    durationInMin: Yup.number().nullable(),
  })
}

export const convertCoachNoteDraftToFormik = (coachNoteDraft: CoachNoteDraft): CoachNoteFormikType => {
  return {
    ...coachNoteDraft,
  }
}

export const convertFormikToCoachNoteDraft = (coachNoteFormik: CoachNoteFormikType): CoachNoteDraft => {
  return {
    ...coachNoteFormik,
  }
}

export type AthleteNoteFormikType = {
  id: string | null
  note: string
}

export function getAthleteNoteBlockValidationSchema() {
  return Yup.object().shape({
    note: requiredInput(Yup.string()),
  })
}

export const convertAthleteNoteDraftToFormik = (athleteNoteDraft: AthleteNoteDraft): AthleteNoteFormikType => {
  return {
    ...athleteNoteDraft,
  }
}

export const convertFormikToAthleteNoteDraft = (athleteNoteFormik: AthleteNoteFormikType): AthleteNoteDraft => {
  return {
    ...athleteNoteFormik,
  }
}
